const initHeader = async () => {
  /*
    =========================================
    ⚛️ Header State Management
    =========================================
  */
  window.Scoutside = window?.Scoutside || {}
  /* =========================================
      CUSTOMER STATE
      ========================================= */
  window.Scoutside.customer = {
    ...window.Scoutside.customer,
    wholesaleBalanceModalData: sessionStorage.getItem(
      'SS:customer_wholesale_balance'
    ),
    setWholesaleBalanceModalData: (data) => {
      window.Scoutside.customer.wholesaleBalanceModalData = JSON.stringify(data)

      // We set session storage instead of local to allow the modal to only display once per session, will re-appear once a session ends and re-opens
      sessionStorage.setItem(
        'SS:customer_wholesale_balance',
        JSON.stringify(data)
      )
      document.dispatchEvent(
        new CustomEvent('setWholesaleBalanceModalData', {
          detail: {
            wholesaleBalanceModalData:
              window.Scoutside.customer.wholesaleBalanceModalData
          }
        })
      )
      window.Scoutside.Wholesale.openWholesaleBalanceModal()
    },
    fetchWholesaleBalanceModalData: async () => {
      if (
        window.Scoutside.customer.isWholesale &&
        window.Scoutside.customer.wholesaleAPIBearerToken &&
        !window.Scoutside.customer.wholesaleBalanceModalData
      ) {
        try {
          const customer_account_info_response = await fetch(
            'https://grassroots.azurewebsites.net/api/customer/account_info',
            {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                Authorization:
                  'Bearer ' + window.Scoutside.customer.wholesaleAPIBearerToken
              },
              body: JSON.stringify({
                clientId: window.Scoutside.customer.id.toString(),
                shopifyCustomerId: window.Scoutside.customer.id
              }),
              redirect: 'follow'
            }
          )
          const customer_account_info =
            await customer_account_info_response.json()
          window.Scoutside.customer.setWholesaleBalanceModalData(
            customer_account_info
          )
        } catch (error) {
          console.log('Error Fetching Wholesale Balance Information', error)
        }
      }
    },
    setYardAreaCalculatorTotal: (data) => {
      localStorage.setItem("SS:total_yard_area", data)

      document.dispatchEvent(
        new CustomEvent('setTotalYardArea', { detail: {
          totalYardArea: data
        } })
      )
    },
    yardAreaCalculatorTotal: localStorage.getItem("SS:total_yard_area")
  }
  /* =========================================
      WHOLESALE STATE
      ========================================= */
  window.Scoutside.Wholesale = {
    ...window.Scoutside.Wholesale,
    // Wholesale Balance Modal Open State
    wholesaleBalanceModalOpen: false,
    closeWholesaleBalanceModal: () => {
      window.Scoutside.Wholesale.wholesaleBalanceModalOpen = false
      document.dispatchEvent(
        new CustomEvent('toggleWholesaleBalanceModal', {
          detail: {
            wholesaleBalanceModalOpen:
              window.Scoutside.Wholesale.wholesaleBalanceModalOpen
          }
        })
      )
    },
    openWholesaleBalanceModal: () => {
      window.Scoutside.Wholesale.wholesaleBalanceModalOpen = true
      document.dispatchEvent(
        new CustomEvent('toggleWholesaleBalanceModal', {
          detail: {
            wholesaleBalanceModalOpen:
              window.Scoutside.Wholesale.wholesaleBalanceModalOpen
          }
        })
      )
    },
    toggleWholesaleBalanceModal: () => {
      window.Scoutside.Wholesale.wholesaleBalanceModalOpen =
        !window.Scoutside.Wholesale.wholesaleBalanceModalOpen
      document.dispatchEvent(
        new CustomEvent('toggleWholesaleBalanceModal', {
          detail: {
            wholesaleBalanceModalOpen:
              window.Scoutside.Wholesale.wholesaleBalanceModalOpen
          }
        })
      )
    }
  }

  /* =========================================
    LOCATION STATE
    ========================================= */
  window.Scoutside.LocationState = {
    // Zipcode Modal Open State
    ...window.Scoutside.LocationState,
    zipcodeModalOpen: false,
    closeZipcodeModal: () => {
      window.Scoutside.LocationState.zipcodeModalOpen = false
      document.dispatchEvent(
        new CustomEvent('toggleZipcodeModal', {
          detail: {
            zipcodeModalOpen: window.Scoutside.LocationState.zipcodeModalOpen
          }
        })
      )
    },
    toggleZipcodeModal: () => {
      window.Scoutside.LocationState.zipcodeModalOpen =
        !window.Scoutside.LocationState.zipcodeModalOpen
      document.dispatchEvent(
        new CustomEvent('toggleZipcodeModal', {
          detail: {
            zipcodeModalOpen: window.Scoutside.LocationState.zipcodeModalOpen
          }
        })
      )
    },
    // Zipcode State
    zipcode: localStorage.getItem('SS:customer_zipcode'),
    setZipCode: (zipcode) => {
      if (zipcode !== window.Scoutside.LocationState.zipcode) {
        // Reset the selected location & distance for each location if the zipcode has changed (so we can re-order by distance)
        window.Scoutside.LocationState.selectedLocation = null
        window.Scoutside.LocationState.locations =
          window.Scoutside.LocationState.locations.map((location) => {
            location.distance = null
            return location
          })
        window.Scoutside.LocationState.setSearchedLocation(zipcode)
      } else {
        window.Scoutside.LocationState.setSearchedLocation(
          window.Scoutside.LocationState.searchedLocation
        )
      }

      localStorage.setItem('SS:customer_zipcode', zipcode)
      window.Scoutside.LocationState.zipcode = zipcode
      document.dispatchEvent(
        new CustomEvent('setZipCode', {
          detail: {
            zipcode
          }
        })
      )
      window.Scoutside.LocationState.closeZipcodeModal()

      if (!localStorage.getItem('SS:blacklist_products')) {
        window.Scoutside.ZipBlacklist?.setZipCode(zipcode)
      }
    },
    // Lat/Long state
    latitude: localStorage.getItem('SS:customer_latitude'),
    longitude: localStorage.getItem('SS:customer_longitude'),
    setCoords: (latitude, longitude) => {
      if (latitude !== window.Scoutside.LocationState.latitude || longitude !== window.Scoutside.LocationState.longitude) {
        // Reset the selected location & distance for each location if the zipcode has changed (so we can re-order by distance)
        window.Scoutside.LocationState.selectedLocation = null
        window.Scoutside.LocationState.locations = window.Scoutside.LocationState.locations.map((location) => {
          location.distance = null
          return location
        })
      }

      localStorage.setItem('SS:customer_latitude', latitude)
      localStorage.setItem('SS:customer_longitude', longitude)
      window.Scoutside.LocationState.latitude = latitude
      window.Scoutside.LocationState.longitude = longitude

      document.dispatchEvent(new CustomEvent('setCoords', {
        detail: { latitude, longitude }
      }))

      window.Scoutside.LocationState.closeZipcodeModal()
    },
    sortingMethod: localStorage.getItem('SS:sorting_method') || 'coords',
    setSortingMethod: (method = 'coords') => {
      localStorage.setItem('SS:sorting_method', method)
      window.Scoutside.LocationState.sortingMethod = method
    },
    setLocationInfoFromIPAddress: async () => {
      // Get the user's zipcode based on IP Address
      const locationResponse = await fetch(`https://ipapi.co/json/`)
      const data = await locationResponse.json()

      const { postal, latitude, longitude } = data

      window.Scoutside.LocationState.setCoords(latitude, longitude)
      window.Scoutside.LocationState.setZipCode(postal)
    },
    searchedLocation: localStorage.getItem('SS:customer_searched_location'),
    setSearchedLocation: (location) => {
      // Reset the selected location & distance for each location (so we can re-order by distance)
      if (location !== window.Scoutside.LocationState.searchedLocation) {
        window.Scoutside.LocationState.selectedLocation = null
        window.Scoutside.LocationState.locations =
          window.Scoutside.LocationState.locations.map((location) => {
            location.distance = null
            return location
          })
      }

      window.Scoutside.LocationState.searchedLocation = location
      localStorage.setItem('SS:customer_searched_location', location)
      document.dispatchEvent(
        new CustomEvent('setSearchedLocation', {
          detail: {
            searchedLocation: window.Scoutside.LocationState.searchedLocation
          }
        })
      )

      if (window.Scoutside.LocationState.sortingMethod === 'distanceMatrix') {
        window.Scoutside.LocationState.orderLocationsByDistanceFromSearchedLocation()
      } else {
        window.Scoutside.LocationState.orderLocationsByCoords()
      }
    },
    selectedLocation: localStorage.getItem('SS:customer_selected_location'),
    /**
     * Sets the selected location by id
     * @param {string} locationId
     * @returns {void}
     */
    setSelectedLocation: (locationId) => {
      if (locationId && typeof locationId === 'string') {
        // Esnure location exists and has pickup enabled
        const targetLocation = window.Scoutside.LocationState.locations.find(({ id }) => id === locationId)
        if (!targetLocation) {
          console.error('Cannot select location that does not exist', locationId)
          return
        }

        if (!targetLocation) {
          console.error('Cannot select location that does not have pickup enabled', locationId)
          return
        }
      }

      window.Scoutside.LocationState.selectedLocation = locationId
      localStorage.setItem('SS:customer_selected_location', locationId)
      document.dispatchEvent(
        new CustomEvent('setSelectedLocation', {
          detail: {
            selectedLocation: window.Scoutside.LocationState.selectedLocation
          }
        })
      )
    },
    // Store Location Information State
    locations: [],
    setLocations: async () => {
      const key = window.Scoutside.Variables.locationsKey || ''
      const cachedObj = localStorage.getItem('SS:locations')

      if (cachedObj) {
        const parsed = JSON.parse(cachedObj)
        if (parsed.key === key && parsed.locations.length) {
          window.Scoutside.LocationState.locations = parsed.locations
          return
        }
      }

      await window.Scoutside.LocationState.setLocationsFromAPI()
    },
    setLocationsFromAPI: async () => {
      const location_results = await fetch(
        window.Scoutside.Variables.graphQLURL,
        {
          method: 'POST',
          headers: window.Scoutside.Variables.graphQLHeaders,
          body: JSON.stringify({
            query: `query fetchLocations {
              locations(first: 50) {
                nodes {
                  id
                  name
                  address {
                    address1
                    zip
                    provinceCode
                    province
                    phone
                    longitude
                    latitude
                    formatted
                    countryCode
                    country
                    city
                    address2
                  }
                  metafield(namespace: "super-sod", key: "zone-zipcodes") {
                    value
                  }
                }
              }
            }`
          })
        }
      )
      const location_data = await location_results.json()
      const formattedLocations = location_data.data.locations.nodes.map(node => ({
        ...node,
        latitude: node.address.latitude || null,
        longitude: node.address.longitude || null,
        pickup: true
      }))

      const deliveryOnlyLocations = window.Scoutside.shop.deliveryOnlyLocations.map(location => ({
        ...location,
        latitude: location.address.latitude || null,
        longitude: location.address.longitude || null,
        pickup: false,
        metafield: {
          value: JSON.stringify(location.metafield.value)
        }
      }))

      const mergedLocations = [...formattedLocations, ...deliveryOnlyLocations]

      window.Scoutside.LocationState.locations = mergedLocations
      const cachedLocations = JSON.stringify({
        key: window.Scoutside.Variables.locationsKey || '',
        locations: mergedLocations
      })

      localStorage.setItem('SS:locations', cachedLocations)

      document.dispatchEvent(
        new CustomEvent('setLocationsFromAPI', {
          detail: {
            locations: mergedLocations
          }
        })
      )
    },
    orderLocationsByCoords: async () => {
      const deg2rad = (deg) => deg * (Math.PI / 180)

      const { latitude: cxLat, longitude: cxLon, locations } = window.Scoutside.LocationState
      const sortedLocations = locations.filter(location => location.pickup).map(location => {
        const { latitude: storeLat, longitude: storeLon } = location
        const earthRadius = 6371; // Radius of the earth in km
        const deltaLat = deg2rad(storeLat - cxLat);  // deg2rad below
        const deltaLon = deg2rad(storeLon - cxLon);
        const a =
          Math.sin(deltaLat / 2) * Math.sin(deltaLat / 2) +
          Math.cos(deg2rad(cxLat)) * Math.cos(deg2rad(storeLat)) *
          Math.sin(deltaLon / 2) * Math.sin(deltaLon / 2);
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        const distance = earthRadius * c; // Distance in km

        return { ...location, distance: { value: distance } }
      }).sort((a, b) => a.distance.value - b.distance.value)

      const mergedStores = [...sortedLocations, ...locations.filter(location => !location.pickup)]

      window.Scoutside.LocationState.locations = mergedStores
      const cachedLocations = JSON.stringify({
        key: window.Scoutside.Variables.locationsKey,
        locations: mergedStores
      })

      localStorage.setItem('SS:locations', cachedLocations)

      // If no location has been chosen, default to the nearest location
      if (!window.Scoutside.LocationState.selectedLocation) {
        window.Scoutside.LocationState.setSelectedLocation(
          mergedStores.find(location => location.pickup).id
        )
      } else {
        window.Scoutside.LocationState.setSelectedLocation(
          window.Scoutside.LocationState.selectedLocation
        )
      }

      document.dispatchEvent(new CustomEvent('orderLocations', {
        detail: { locations: mergedStores }
      }))
    },
    callDistanceMatrixService: async (origins, destinations) => {
      const service = window.Scoutside.distanceMatrixService
      const res = await service.getDistanceMatrix({
        origins,
        destinations,
        travelMode: 'DRIVING'
      })
      return res;
    },
    orderLocationsByDistanceFromSearchedLocation: async () => {
      const origins = [window.Scoutside.LocationState.searchedLocation]
      const pickupLocations = window.Scoutside.LocationState.locations.filter(location => location.pickup)
      const destinations = pickupLocations.map(
        (location) => location.address.zip
      )
      const hasDistance = !!pickupLocations[0]?.distance

      if (!hasDistance) {
        // split destinations array into chunks of 20
        const chunkSize = 20
        const chunks = []
        for (let i = 0; i < destinations.length; i += chunkSize) {
          chunks.push(destinations.slice(i, i + chunkSize))
        }

        const responses = await Promise.all(
          chunks.map(async (chunk) => {
            const res = await window.Scoutside.LocationState.callDistanceMatrixService(origins, chunk)

            return res
          }
        ))

        // merge all responses into one object
        const mergedResponses = {
          origin_addresses: responses[0].origin_addresses,
          rows: [{ elements: responses.reduce((acc, res) => {
            acc.push(...res.rows[0].elements)
            return acc
          }, []) }]
        };

        const orderedStores = mergedResponses.rows[0].elements.map((storeLocation, index) => {
          const pickupLocation = pickupLocations[index]

          return {
            ...pickupLocation,
            distance: storeLocation.distance
          }
        }).sort((a, b) => a.distance.value - b.distance.value)

        const mergedStores = [...orderedStores, ...window.Scoutside.LocationState.locations.filter(location => !location.pickup)]

        window.Scoutside.LocationState.locations = mergedStores
        const cachedLocations = JSON.stringify({
          key: window.Scoutside.Variables.locationsKey,
          locations: mergedStores
        })

        localStorage.setItem('SS:locations', cachedLocations)

        // If no location has been chosen, default to the nearest location
        if (!window.Scoutside.LocationState.selectedLocation) {
          window.Scoutside.LocationState.setSelectedLocation(
            mergedStores.find(location => location.pickup).id
          )
        }

        document.dispatchEvent(new CustomEvent('orderLocations', {
          detail: { locations: mergedStores }
        }))
      } else {
        document.dispatchEvent(
          new CustomEvent('orderLocations', {
            detail: {
              locations: window.Scoutside.LocationState.locations
            }
          })
        )

        window.Scoutside.LocationState.setSelectedLocation(
          window.Scoutside.LocationState.selectedLocation
        )
      }
    },
    // Store Selector Drawer Open State
    storeSelectorDrawerOpen: false,
    closeStoreSelectorDrawer: () => {
      window.Scoutside.LocationState.storeSelectorDrawerOpen = false
      document.dispatchEvent(
        new CustomEvent('toggleStoreSelectorDrawer', {
          detail: {
            storeSelectorDrawerOpen:
              window.Scoutside.LocationState.storeSelectorDrawerOpen
          }
        })
      )
    },
    toggleStoreSelectorDrawer: (e, availableLocations = null) => {
      window.Scoutside.LocationState.storeSelectorDrawerOpen =
        !window.Scoutside.LocationState.storeSelectorDrawerOpen
      document.dispatchEvent(
        new CustomEvent('toggleStoreSelectorDrawer', {
          detail: {
            availableLocations,
            storeSelectorDrawerOpen:
              window.Scoutside.LocationState.storeSelectorDrawerOpen
          }
        })
      )
    }
  }

  /*
    ============================================================
    👂 Init Event Handlers, & Listeners for needed components
    ============================================================
  */
  await initStoreSelector() // Initialize The Store Selector
  await initZipcodeModal() // Initialize The Zipcode Modal
  await initWholesaleBalanceModal() // Initialize The Wholesale Balance Modal

  /*
    ============================================================
    ⚛️ Fetch Wholesale Balance, Locations, Zipcode, & Set Initial State
    ============================================================
  */

  // If no locations are set, fetch it from the graphql api
  if (!window.Scoutside.LocationState.locations.length) {
    await window.Scoutside.LocationState.setLocations()
  }

  // If no zipcode is set, fetch it from the geolocation API
  const { latitude, longitude, zipcode } = window.Scoutside.LocationState
  if (latitude !== null && longitude !== null && zipcode) {
    await window.Scoutside.LocationState.setCoords(latitude, longitude)
    await window.Scoutside.LocationState.setZipCode(zipcode)
  } else {
    await window.Scoutside.LocationState.setLocationInfoFromIPAddress()
  }

  // If the customer is wholesale, fetch their balance information
  if (
    window.Scoutside.customer.isWholesale &&
    window.Scoutside.customer.wholesaleAPIBearerToken
  ) {
    await window.Scoutside.customer.fetchWholesaleBalanceModalData()
  }
}

initHeader()
